<template>
  <div class="c-keyboard" v-visible="!loading">
    <img
      class="background"
      :src="images['keyboard_' + version]"
      @load="onLoad"
    />
    <div class="keys">
      <template v-for="(key, index) in keyboardSettings">
        <div
          v-if="srcKeys[key.srcKey]"
          class="key"
          :class="{
            selected: selectedIndex === index,
            changed: !disabled && key.srcKey !== key.dstKey,
            disabled: srcKeys[key.srcKey].disabled,
          }"
          :key="key + index"
          :style="srcKeys[key.srcKey].style"
          @click="$emit('key-click', { index, dstKey: key.dstKey })"
          @dblclick="$emit('key-click', { index, dstKey: key.dstKey })"
        >
          <div class="texts">
            <div
              class="text"
              :key="dstKey + index"
              :style="dstKey.style"
              v-for="(dstKey, index) in dstKeys[key.dstKey] || []"
            >
              {{ dstKey.text }}
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { srcKeys, dstKeys } from "./Keyboard";

export default {
  name: "CKeyboard",
  props: {
    disabled: Boolean,
    selectedIndex: Number,
    keyboardSettings: Array,
    layerIndex: Number,
  },
  data() {
    return {
      loading: true,
      srcKeys: { ...srcKeys },
      dstKeys,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("profile", {
      version: "version",
    }),
  },
  methods: {
    onLoad() {
      this.loading = false;
    },
  },
  watch: {
    layerIndex(layerIndex) {
      if (layerIndex === 1) {
        this.srcKeys.key_esc = {
          ...srcKeys.key_esc,
          disabled: true,
        };
        // this.srcKeys.key_r = {
        //   ...srcKeys.key_r,
        //   disabled: true,
        // };
      } else {
        this.srcKeys.key_esc = srcKeys.key_esc;
        // this.srcKeys.key_r = srcKeys.key_r;
      }
    },
  },
  mounted() {
    if (this.version === "r1") {
      this.srcKeys.KEY_FN = undefined;
    } else {
      this.srcKeys.KEY_FN = srcKeys.KEY_FN;
    }
  },
};
</script>
<style lang="scss" scoped>
.c-keyboard {
  width: 100%;
  position: relative;

  .background {
    width: 100%;
    height: auto;
    position: relative;
    -webkit-user-drag: none;
  }

  .keys {
    width: 87.5%;
    height: 80%;
    position: absolute;
    left: 6.3%;
    top: 9.7%;
    display: flex;
    flex-wrap: wrap;

    .key {
      width: 4%;
      height: 11.7%;
      padding: 0 0.2%;
      position: absolute;
      cursor: pointer;
      box-shadow: none;

      &.selected,
      &:hover {
        box-shadow: 0 0 0px 2px $primary-color inset;
      }

      &.changed {
        background-color: rgba($color: $primary-color, $alpha: 0.001);
      }

      &.disabled {
        pointer-events: none;
      }

      .texts {
        width: 100%;
        height: 100%;
        position: relative;
        font-size: 24px;

        .text {
          width: 200%;
          text-align: left;
          position: absolute;
          left: 0;
          transform: translate(-25%, -50%) scale(0.5);
          letter-spacing: 0;
          line-height: 1.2;
        }
      }
    }
  }
}
</style>
